import { CountdownTimer, MUIIcon, ProgressIndicator, useCalcRemainingTime } from "../../../../widgets";
import { FC, useCallback, useState } from "react";
import { IServiceRequest, ServiceRequestStatus } from "../models";

import { ServiceReqHelper } from "../helpers/helper";
import { ServiceRequestResend } from "./ServiceRequestResend";
import { addMinutes } from "../../timeline/helper";
import { useInterval } from "react-use";
import { useServiceRequestContext } from "../service-request";

interface IServiceRequestActionsProps {
    isSendingForApproval?: boolean,
    onCancel: (requestId: string) => void
}

export const ServiceRequestActions: FC<IServiceRequestActionsProps> = ({isSendingForApproval, onCancel }) => {
    const { result, refetch, updateServiceRequest } = useServiceRequestContext()
    const { serviceRequest, service } = result || {}
    const endTime = addMinutes(serviceRequest?.endTime, service?.otpTimer)
    const { isFuture } = useCalcRemainingTime({ endTime });
    const [cancelling, setCancelling] = useState<boolean>(false)

    useInterval(() => {
        if (serviceRequest?.statusCode !== ServiceRequestStatus.Submitted && serviceRequest?.statusCode !== ServiceRequestStatus.AutoApproved && serviceRequest?.statusCode !== ServiceRequestStatus.Approved)
            return;

        refetch()
    }, 5000)

    const resendButtons = (serviceRequest: IServiceRequest) => {
        if (!ServiceReqHelper.isCancellable(serviceRequest?.statusCode) || !serviceRequest.endTime || isFuture !== false)
            return <></>

        if ((service?.maxApprovalAttempts && serviceRequest.counter) &&
            service.maxApprovalAttempts <= serviceRequest.counter) {
            return <></>
        }

        return <>
            <ServiceRequestResend serviceRequest={serviceRequest} />
        </>
    }

    const countdownTimer = useCallback((endTime?: Date) => {
        if (!endTime || !service?.otpTimer || service?.otpTimer <= 0 || isFuture !== true ||
            !ServiceReqHelper.isCancellable(serviceRequest?.statusCode))
            return <></>

        return <>{
            serviceRequest?.statusCode === ServiceRequestStatus.Submitted &&
            <CountdownTimer endTime={endTime} label='Waiting for Approval' />
        }
        </>

        // eslint-disable-next-line
    }, [isFuture, service, serviceRequest])

    const handleCancel = () => {
        if (!serviceRequest) return;

        setCancelling(true)
        updateServiceRequest({
            ...serviceRequest,
            statusCode: ServiceRequestStatus.Cancelled
        })
            .then(() => onCancel(serviceRequest.id))
            .finally(() => setCancelling(false))
    }

    const cancellationButton = () => {
        if (!ServiceReqHelper.isCancellable(serviceRequest?.statusCode) || serviceRequest?.allowCancellation === false)
            return <></>

        return <>
            <button
                disabled={cancelling}
                type="button" onClick={handleCancel} className='btn btn-sm btn-danger py-2 align-self-center'>
                {!cancelling && <>
                    <MUIIcon iconName={"CancelOutlined"} className="me-1" />
                    Cancel the request
                </>}
                {cancelling && <>
                    <ProgressIndicator show={true} message='Please wait...' />
                </>}
            </button>
        </>
    }

    if (!serviceRequest)
        return <></>

    if (!serviceRequest.endTime && serviceRequest?.statusCode === ServiceRequestStatus.Submitted && isSendingForApproval)
        return <ProgressIndicator className="my-3" show={true} message='Sending approval request...' />

    return <div className='my-3'>
        <div className="d-flex gap-3">
            {countdownTimer(endTime)}
            <div className="flex-fill" />
            <div className="d-flex gap-3">
                {cancellationButton()}
                {resendButtons(serviceRequest)}
            </div>
        </div>
    </div>
}